import React, { useEffect, useState } from "react";
import Styles from "./userCard.module.css";
import { Card } from "@mui/material";
import Button from "../../Subcomponents/Button";
import LeadStatusChip from "../../Subcomponents/LeadStatusChip";
import Dot from "../../Components/Icons/Dot";
import WhatsApp from "../../Components/Icons/WhatsApp";
import CalendarTodayOutlinedIcon from "@mui/icons-material/CalendarTodayOutlined";
import { WhatsappShareButton } from "react-share";
import { WhatsappIcon } from "react-share";
import ThreeDotsMenu from "../ThreeDotsMenu";
//TimeAgo
import ReactTimeAgo from "react-time-ago";
// import TimeAgo from "javascript-time-ago";
// import en from "javascript-time-ago/locale/en.json";

import { useSelector } from "react-redux";
//Modals
import TimeLineAndNotes from "../../Modals/TimeLineAndNotes/TimeLineAndNotes";
import AddPreference from "../../Modals/AddPreference/AddPreference";
import CustomInput from "../CustomInput";
import { getAllotedData } from "../../Services/LeadService";
import { Box, Divider } from "@material-ui/core";

import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import CallIcon from "@mui/icons-material/Call";
function LeadCard({ data, actionStyles, returnButtonResp }) {
  // TimeAgo.setDefaultLocale(en.locale);
  // TimeAgo.addLocale(en);
  let loggedInUser = {};
  loggedInUser = useSelector((state) => state.Auth.user);
  const [style, setStyle] = useState(null);
  const WhatsAppMessage = `Hello Mr.${data.personName}%0a %0aGreetings from Vilas Javdekar Developers%0a %0aYou have been successfully registered with us through one of our esteemed Channel Partners.We will always be at your service to help you book your Dream Home with VJ. Looking forward to welcome you to our VJ Parivaar soon!Our Official Website is :www.javdekars.com.-Team VJ.`;
  const [dropdownList, setDropdownList] = useState([
    "Add preference",
    "Timeline and Notes",
  ]);
  const [timeLineAndNotesModal, setTimeLineAndNotesModal] = useState(false);
  const [addPreferenceModal, setAddPreferenceModal] = useState(false);
  const [showDetails, setShowDetails] = useState(false);
  const [copyLeadObj, setCopyLeadObj] = useState(data);
  useEffect(() => {
    defineColorSchema();
    return () => { };
  }, []);
  function defineColorSchema() {
    let obj = {};
    if (data.status === "Allotment Done") {
      obj.chipColor = "#5925DC";
      obj.chipBackgroundColor = "#F4F3FF";
    } else if (data.status === "Claimed") {
      obj.chipColor = "#F79009";
      obj.chipBackgroundColor = "#FFFAEB";
    } else if (data.status === "Unit On Hold") {
      obj.chipColor = "#FF4405";
      obj.chipBackgroundColor = "#FFE6D5";
    } else if (data.status === "Allotment Partial Payment Done") {
      obj.chipColor = "#C01048";
      obj.chipBackgroundColor = "#FFF1F3";
    } else if (data.status === "Token Payment Pending") {
      obj.chipColor = "#C11574";
      obj.chipBackgroundColor = "#FDF2FA";
    } else if (data.status === "Token Partial Payment Done") {
      obj.chipColor = "#BC1B06";
      obj.chipBackgroundColor = "#FFF4ED";
    } else if (data.status === "Token Payment Complete") {
      obj.chipColor = "#3538CD";
      obj.chipBackgroundColor = "#EEF4FF";
    } else if (data.status === "Site Visit Done") {
      obj.chipColor = "#5925DC";
      obj.chipBackgroundColor = "#F4F3FF";
    } else if (data.status === "Site Visit Scheduled") {
      obj.chipColor = "#5925DC";
      obj.chipBackgroundColor = "#F4F3FF";
    } else if (data.status === "Closed") {
      obj.chipColor = "#027A48";
      obj.chipBackgroundColor = "#ECFDF3";
    } else if (data.status === "Checkpoint One Cleared") {
      obj.chipColor = "#6941C6";
      obj.chipBackgroundColor = "#F4EBFF";
    } else if (data.status === "Checkpoint Two Cleared") {
      obj.chipColor = "#0E7090";
      obj.chipBackgroundColor = "#ECFDFF";
    } else if (
      data.status === "Allotment Payment Complete" ||
      data.status === "Agreement Done" ||
      data.status === "Change Unit Requested" ||
      data.status === "Cancellation Confirmation Pending" ||
      data.status === "Cancel Unit Done" ||
      data.status === "Cancel Unit Not Done" ||
      data.status === "Change Unit Confirmation Rejected" ||
      data.status === "Change Unit Confirmed" ||
      data.status === "Change Unit Rejected" ||
      data.status === "Cancel Unit Requested" ||
      data.status === "PreSelect Payment Pending" ||
      data.status === "PreSelect Unit on Hold" ||
      data.status === "Preselect not confirmed" ||
      data.status === "PreSelect Partial Payment Done" ||
      data.status === "PreSelect Confirmation Pending") {
      obj.chipColor = "#5925DC";
      obj.chipBackgroundColor = "#F4F3FF";
    }
    else if (data.status === "Unit on Hold") {
      obj.chipColor = "#C01048";
      obj.chipBackgroundColor = "#FFF1F3";
    }
    else if (data.status === "Allotment Payment Pending") {
      obj.chipColor = "#C01048";
      obj.chipBackgroundColor = "#FFF1F3";
    } else if (
      data.status === "Allotment Partial Payment Done" ||
      data.status === "Preselect payment not done"
    ) {
      obj.chipColor = "#C01048";
      obj.chipBackgroundColor = "#FFF1F3";
    }
    else {
      obj.chipBackgroundColor = " #ececec";
      // obj.chipColor = "#667085";
    }

    setStyle(obj);
  }
  function returnButtonRespose(value) {
    console.log(value);
    if (value) {
      returnButtonResp(true);
    }
  }

  function getLeadAlotedProject() {
    getAllotedData(copyLeadObj.leadId)
      .then((resp) => {
        console.log(resp);
        resp.data = resp.data.map((each) => ({
          ...each,
          WhatsAppMessage:
            each.status === "Payment Complete" && each.kycFormFilled
              ? `Hello Mr.${copyLeadObj.leadname
              },%0a %0aGreetings from Vilas Javdekar Developers !%0a %0aYour selection ${each?.unitId?.projectId?.projectName
                ? each?.unitId?.projectId?.projectName
                : each?.inventoryMergedId?.projectId?.projectName
              }.%0a Your Allotment payment status:${each.status
              }.%0aCustomer Portal link:${process.env.REACT_APP_CUSTOMER_PORTAL
              }.%0a %0aRegards,Team VJ`
              : each.status === "Payment Complete" && !each.kycFormFilled
                ? `Hello Mr.${copyLeadObj.leadname
                },%0a %0aGreetings from Vilas Javdekar Developers !%0a %0aYour selection ${each?.unitId?.projectId?.projectName
                  ? each?.unitId?.projectId?.projectName
                  : each?.inventoryMergedId?.projectId?.projectName
                }.%0aYour Allotment payment status:${each.status
                }.%0aPlease complete your kyc through Customer Portal link:${process.env.REACT_APP_CUSTOMER_PORTAL
                }.%0a %0aRegards,Team VJ`
                : each.status === "Partial Payment Done" && !each.kycFormFilled
                  ? `Hello Mr.${copyLeadObj.leadname
                  },%0a %0aGreetings from Vilas Javdekar Developers !%0a %0aYour selection ${each?.unitId?.projectId?.projectName
                    ? each?.unitId?.projectId?.projectName
                    : each?.inventoryMergedId?.projectId?.projectName
                  }.%0aYour Allotment payment status:${each.status
                  }.%0aYou will recieve a confirmation email with more information after the payment has been processed and the booking details form has been completed.${process.env.REACT_APP_CUSTOMER_PORTAL
                  }.%0a %0aRegards,Team VJ`
                  : each.status === "Partial Payment Done" && each.kycFormFilled
                    ? `Hello Mr.${copyLeadObj.leadname
                    },%0a %0aGreetings from Vilas Javdekar Developers !%0a %0aYour current Status:${copyLeadObj.leadstatus
                    }.%0aYour Allotment payment status:${each.status
                    }.%0aYour selection ${each?.unitId?.projectId?.projectName
                      ? each?.unitId?.projectId?.projectName
                      : each?.inventoryMergedId?.projectId?.projectName
                    }.%0aPlease complete your payment through:${process.env.REACT_APP_CUSTOMER_PORTAL
                    }.%0a %0aRegards,Team VJ`
                    : each.status === "Payment Pending"
                      ? `Hello Mr.${copyLeadObj.leadname
                      },%0a %0aGreetings from Vilas Javdekar Developers !%0a %0aYour current Status:${copyLeadObj.leadstatus
                      }.%0aYour Allotment payment status:${each.status
                      }.%0aYour selection ${each?.unitId?.projectId?.projectName
                        ? each?.unitId?.projectId?.projectName
                        : each?.inventoryMergedId?.projectId?.projectName
                      }%0aPlease Confirm your booking by paying through the link below:%0a${process.env.REACT_APP_CUSTOMER_PORTAL
                      }.%0aYou will recieve a confirmation email with more information after the payment has been processed and the booking details form has been completed. %0aRegards,Team VJ`
                      : `Hello Mr.${copyLeadObj.leadname
                      },%0a %0aGreetings from Vilas Javdekar Developers !%0a %0aYour current Status:${copyLeadObj.leadstatus
                      }.%0aYour Allotment payment status:${each.status
                      }.Your selection ${each?.unitId?.projectId?.projectName
                        ? each?.unitId?.projectId?.projectName
                        : each?.inventoryMergedId?.projectId?.projectName
                      }%0aPlease Confirm your booking by paying through the link below:%0a:${process.env.REACT_APP_CUSTOMER_PORTAL
                      }.%0aYou will recieve a confirmation email with more information after the payment has been processed and the booking details form has been completed. %0aRegards,Team VJ`,
        }));
        let allotmentData = resp.data;

        setCopyLeadObj((pre) => {
          return { ...pre, allotmentData };
        });
        console.log(copyLeadObj);
      })
      .catch((err) => {
        console.log(err);
      });
  }
  function numberWithCommas(x) {
    return x?.toString().replace(/\B(?=(?:(\d\d)+(\d)(?!\d))+(?!\d))/g, ",");
  }
  function toCalculateValueFromPercent(percentage, bsp) {
    var numVal1 = Number(bsp);
    var numVal2 = Number(percentage) / 100;

    var totalValue = numVal1 * numVal2;

    return Math.ceil(totalValue);
  }
  return (
    <Card className={Styles.userCard}>
      <div className={Styles.head}>
        <div className={Styles.nm} style={{ width: "auto" }}>
          <div className={Styles.pref}>{data.personName[0]}</div>
          <div className={Styles.title}>
            <div className={Styles.name}>
              {data.personName}
              <div className={Styles.fosId}>
                {"VJ" +
                  data?.leadDisplayId.replace(
                    data?.leadDisplayId.substring(8, 12),
                    "-" + data.leadDisplayId.substring(8, 12)
                  )}
              </div>
            </div>
          </div>
        </div>
        <div className={Styles.headerDiv2}>
          <div className={Styles.status}>
            <LeadStatusChip
              style={{
                color: style?.chipColor,
                backgroundColor: style?.chipBackgroundColor,
              }}
              label={data.status}
              icon={<Dot width={"0.5rem"} height={"0.5rem"} />}
            />
          </div>
          <div>
            <ReactTimeAgo
              style={{ fontSize: "1.2rem" }}
              date={data?.statuschangeddate ? data?.statuschangeddate : data?.last_updated_at}
              locale="en-US"
            />
          </div>
          <div>
            <ThreeDotsMenu
              list={dropdownList}
              selectedValue={(e) => {
                console.log(e);
                if (e === "Timeline and Notes") {
                  setTimeLineAndNotesModal(true);
                } else if (e === "Add preference") {
                  setAddPreferenceModal(true);
                }
              }}
            />
          </div>
        </div>
      </div>
      <div className={Styles.body}>
        <div className={Styles.leadContact}>
          <div className={Styles.lead_phone}>+{data.phoneNumber}</div> |
          <div className={Styles.email}>{data.email}</div>
        </div>
        {/* </div> */}
        {/* {loggedInUser?.cpType === "Entity" && ( */}
        <div className={Styles.lead}>FOS : {data.FOS === '-' ? 'NA' : data.FOS}</div>
        {/* )} */}
        {data?.status !== 'Unclaimed' && (
          <div>
            <span className={Styles.label}>VJ SM:</span>
            <span className={Styles.labelValue}>
              {" "}
              {data?.salesname === null ? "-" : data?.salesname}
            </span>
          </div>

        )}

        <div className={Styles.wrapperWhatsAppShare} styles={actionStyles}>
          <a
            href={`https://wa.me/${data.phoneNumber}/?text=${WhatsAppMessage}`}
            data-action="share/whatsapp/share"
            target="_blank"
            rel="noopener noreferrer"
          >
            <WhatsappIcon size={32} round={true} />
          </a>
        </div>
      </div>
      <div className={Styles.wrapperCreatedAt}>
        <div>
          <CalendarTodayOutlinedIcon
            style={{ color: "#1D2939", verticalAlign: "middle" }}
          />
        </div>
        <div className={Styles.fosId}>Created At:</div>
        <div className={Styles.fosId}>
          {new Date(data.statuschangeddate).toDateString()},{" "}
          {new Date(data.statuschangeddate).toLocaleTimeString([], {
            hour: "2-digit",
            minute: "2-digit",
          })}
        </div>
      </div>


      {showDetails &&
        copyLeadObj?.allotmentData?.map((eachAllotment) => {
          return (
            <div style={{ marginTop: "2rem" }}>
              <Divider
                sx={{
                  width: "100%",
                  borderColor: "#EAECF0",
                  marginBottom: "1.2rem",
                  marginTop: '1rem'
                }}
              />
              <div className={Styles.projectDiv}>
                <div
                  style={{
                    display: "flex",
                    gap: "1rem",
                    alignItems: "center",
                  }}
                >
                  <div className={Styles.projectNameLabel}>
                    <p>Project Name</p>
                  </div>
                  <div className={Styles.label}>
                    <p>:</p>
                  </div>
                  <div className={Styles.projectNameValue}>
                    {eachAllotment?.unitId?.projectId?.projectName ? (
                      <p>{eachAllotment?.unitId?.projectId?.projectName}</p>
                    ) : (
                      <p>
                        {
                          eachAllotment?.inventoryMergedId?.projectId
                            ?.projectName
                        }
                      </p>
                    )}
                  </div>
                </div>
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                  }}
                >
                  <div style={{ display: "flex", gap: "0.5rem" }}>
                    <div>
                      {(eachAllotment.status === "Partial Payment Done" ||
                        eachAllotment.status === "Payment Complete") &&
                        !eachAllotment.kycFormFilled && (
                          <LeadStatusChip
                            label={"Kyc pending"}
                            icon={
                              <Dot width={"0.5rem"} height={"0.5rem"} />
                            }
                            style={{
                              color: "#0E7090",
                              backgroundColor: "#ECFDFF",
                            }}
                          ></LeadStatusChip>
                        )}
                      {eachAllotment.kycFormFilled && (
                        <LeadStatusChip
                          label={"Kyc Done"}
                          icon={<Dot width={"0.5rem"} height={"0.5rem"} />}
                          style={{
                            color: "#0E7090",
                            backgroundColor: "#ECFDFF",
                          }}
                        ></LeadStatusChip>
                      )}
                    </div>
                    <div>
                      <LeadStatusChip
                        style={
                          eachAllotment?.status === "pending"
                            ? {
                              color: "#B54708",
                              backgroundColor: "#FFFAEB",
                            }
                            : eachAllotment?.status === "Payment Complete"
                              ? {
                                color: "#027A48",
                                backgroundColor: "#ECFDF3",
                              }
                              : {
                                color: "#B54708",
                                backgroundColor: "#FFF4ED",
                              }
                        }
                        label={eachAllotment?.status}
                        icon={<Dot width={"0.5rem"} height={"0.5rem"} />}
                      />
                    </div>
                  </div>

                </div>
              </div>
              <div className={Styles.projectDetails}>
                <div style={{ marginTop: "1rem", width: "30%" }} className={Styles.allotmentEachBlock}>
                  <p>Unit</p>
                  {eachAllotment?.unitId !== null ? (
                    <CustomInput
                      value={
                        eachAllotment?.unitId?.wingId?.wingName +
                        "-" +
                        eachAllotment?.unitId?.unitNo
                      }
                      disabled={true}
                    />
                  ) : (
                    <CustomInput
                      value={
                        eachAllotment?.inventoryMergedId?.unit1Id?.wingId
                          ?.wingName +
                        "-" +
                        eachAllotment?.inventoryMergedId?.unit1No +
                        "," +
                        eachAllotment?.inventoryMergedId?.unit1Id?.wingId
                          ?.wingName +
                        "-" +
                        eachAllotment?.inventoryMergedId?.unit2No
                      }
                      disabled={true}
                    />
                  )}
                </div>
                <div style={{ marginTop: "1rem", width: "20%" }} className={Styles.allotmentEachBlock}>
                  <p>Allotment Date</p>
                  <CustomInput
                    // value={new Date(
                    //   eachAllotment?.last_updated_at
                    // ).toLocaleDateString()}
                    value={
                      new Date(eachAllotment?.created_at).toDateString()
                      // new Date( eachAllotment?.last_updated_at).toLocaleTimeString([], {
                      //   hour: "2-digit",
                      //   minute: "2-digit",
                      //  } )
                    }
                    disabled={true}
                  />
                </div>
                <div style={{ marginTop: "1rem", width: "15%" }} className={Styles.allotmentEachBlock}>
                  <p>Paid Amount</p>
                  {eachAllotment?.paidAmount ? (
                    <CustomInput
                      value={
                        "₹" + numberWithCommas(eachAllotment?.paidAmount)
                      }
                      disabled={true}
                    />
                  ) : (
                    <CustomInput
                      value={"₹" + eachAllotment?.paidAmount}
                      disabled={true}
                    />
                  )}
                </div>
                <div style={{ marginTop: "1rem", width: "15%" }} className={Styles.allotmentEachBlock}>
                  <p>Total Cost</p>
                  {eachAllotment?.unitCost?.total ? (
                    <CustomInput
                      value={
                        "₹" +
                        numberWithCommas(eachAllotment?.unitCost?.total)
                      }
                      disabled={true}
                    />
                  ) : (
                    <CustomInput
                      value={"₹" + eachAllotment?.unitCost?.total}
                      disabled={true}
                    />
                  )}
                </div>
                {
                  loggedInUser?.type === "CP" && <div style={{ marginTop: "1rem", width: "15%" }} className={Styles.allotmentEachBlock}>
                    <p>Basic Brokerage</p>
                    {eachAllotment?.unitCost?.bsp && (
                      <CustomInput
                        value={
                          "₹" +
                            numberWithCommas(toCalculateValueFromPercent(new Date(eachAllotment?.created_at) >= new Date("2025-04-01") ? 3 : 2, eachAllotment?.unitCost?.bsp))
                        }
                        disabled={true}
                      />
                    )}
                  </div>
                }

                <div
                  style={{ display: "flex", gap: "2rem" }}
                // style={tabValue==='Unclaimed'||tabValue==='Nuturing'||tabValue==='Site Visit'?{width:"100%",textAlign:'right'}:{}}
                >
                  <a
                    href={`https://wa.me/${copyLeadObj.leadcontactnumber}/?text=${eachAllotment.WhatsAppMessage}`}
                    data-action="share/whatsapp/share"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <WhatsappIcon size={32} round={true} />
                  </a>
                  {/* <a
                        href={`tel:+${copyLeadObj.leadcontactnumber}`}
                        data-action="share/whatsapp/share"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        <CallIcon style={{ width: "4rem", height: '4rem' }} size={32} round={true} />
                      </a> */}
                </div>
              </div>
              <div
                style={{ width: "100%", height: "100%", marginTop: "2rem" }}
              ></div>
            </div>
          );
        })}
      <div className={Styles.footer}>
        {
          //**In tabValue===All we need to show on status
          (copyLeadObj.status === "Token Payment Pending" ||
            copyLeadObj.status === "Token Partial Payment Done" ||
            copyLeadObj.status === "Token Payment Complete" ||
            copyLeadObj.status === "Preselect payment not done" ||
            copyLeadObj.status === "Token Refund Requested" ||
            copyLeadObj.status === "Token Refunded" ||
            copyLeadObj.status === "Token Refund Request Rejected" ||
            copyLeadObj.status === "Token Payment Not Done" ||
            copyLeadObj.status === "Allotment Partial Payment Done" ||
            copyLeadObj.status === "Allotment Refunded" ||
            copyLeadObj.status === "Allotment Payment Complete" ||
            copyLeadObj.status.includes(
              "Cancellation Confirmation Pending"
            ) ||
            copyLeadObj.status === "Cancellation Done" ||
            copyLeadObj.status === "Cancellation Not Done" ||
            copyLeadObj.status === "Change Unit Confirmation Pending" ||
            copyLeadObj.status === "Allotment Payment Pending" ||
            copyLeadObj.status === "Payment Pending" ||
            copyLeadObj.status === "Unit On Hold" ||
            copyLeadObj.status === "PreSelect Payment Pending" ||
            copyLeadObj.status === "Preselect not confirmed" ||
            copyLeadObj.status === "PreSelect Unit On Hold" ||
            copyLeadObj.status === "PreSelect Confirmation Pending" ||
            copyLeadObj.status === "Unit Change Requested" ||
            copyLeadObj.status === "PreSelect Price Confirmation Pending" ||
            copyLeadObj.status === "PreSelect Partial Payment Done" ||
            copyLeadObj.status === "Checkpoint One Cleared" ||
            copyLeadObj.status === "Checkpoint Two Cleared" ||
            copyLeadObj.status === "Change Unit Requested" ||
            copyLeadObj.status === "Change Unit Confirmation Pending" ||
            copyLeadObj.status === "Change Unit Confirmation Rejected" ||
            copyLeadObj.status === "Change Unit Confirmed" ||
            copyLeadObj.status === "Change Unit Rejected" ||
            copyLeadObj.status === "Site Visit Done" ||
            copyLeadObj.status === "Agreement Done" ||
            copyLeadObj.status === "Allotment Done") && (
            <div>
              <Box>
                {!showDetails ? (
                  <Button
                    iconPosition={"right"}
                    padding={"0.5rem"}
                    clicked={() => {
                      setShowDetails(true);
                      // if (tabValue === "Token" || tabValue === "Token" || tabValue === "Allotment" || tabValue === "All") {
                      getLeadAlotedProject();
                      // }
                    }}
                    btnName={"More Details"}
                    style={{
                      color: "#1570EF",
                      borderRadius: "2.4rem",
                      backgroundColor: "#EFF8FF",
                      fontSize: "1.6rem",
                      lineHeight: "2.4rem",
                      border: "1px solid #EFF8FF",
                    }}
                    btnIcon={
                      <KeyboardArrowDownIcon
                        style={{
                          color: "#1570EF",
                          width: "3rem",
                          height: "3rem",
                        }}
                      />
                    }
                  />
                ) : (
                  <Button
                    iconPosition={"right"}
                    padding={"0.5rem"}
                    clicked={() => setShowDetails(false)}
                    btnName={"Hide Details"}
                    style={{
                      color: "#1570EF",
                      borderRadius: "2.4rem",
                      backgroundColor: "#EFF8FF",
                      fontSize: "1.6rem",
                      lineHeight: "2.4rem",
                      border: "1px solid #EFF8FF",
                    }}
                    btnIcon={
                      <KeyboardArrowUpIcon
                        style={{
                          color: "#1570EF",
                          width: "3rem",
                          height: "3rem",
                        }}
                      />
                    }
                  />
                )}
              </Box>
            </div>
          )
        }
        {(copyLeadObj.status === "Unclaimed" ||
          copyLeadObj.status === "Claimed" ||
          copyLeadObj.status === "Site Visit Scheduled" ||
          copyLeadObj.status === "Site Visit Done") && (
            <div
              style={{
                display: "flex",
                gap: "2rem",
                alignItems: 'center'
              }}
            // style={tabValue==='Unclaimed'||tabValue==='Nuturing'||tabValue==='Site Visit'?{width:"100%",textAlign:'right'}:{}}
            >
              <a
                href={`https://wa.me/${copyLeadObj.leadcontactnumber}/?text=${WhatsAppMessage}`}
                data-action="share/whatsapp/share"
                target="_blank"
                rel="noopener noreferrer"
              >
                <WhatsappIcon size={32} round={true} />
              </a>
              <a
                href={`tel:+${copyLeadObj.leadcontactnumber}`}
                data-action="share/whatsapp/share"
                target="_blank"
                rel="noopener noreferrer"
              >
                {/* <CallIcon
                  style={{ width: "3rem", height: "3rem" }}
                  round={true}
                /> */}
              </a>
            </div>
          )}


      </div>
      {addPreferenceModal && (
        <AddPreference
          open={addPreferenceModal}
          handleClose={() => {
            setAddPreferenceModal(false);
          }}
          data={data}
          returnRes={returnButtonRespose}
        />
      )}
      {timeLineAndNotesModal && (
        <TimeLineAndNotes
          open={timeLineAndNotesModal}
          handleClose={() => {
            setTimeLineAndNotesModal(false);
          }}
          data={data}
        />
      )}
    </Card>
  );
}
export default LeadCard;
